import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Stack, Box, CardActionArea } from '@mui/material';
import { FaUserFriends } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { fetchAllGroups } from '../../controllers/groupManagementController';

const OcakbaşıGruplarıKartı = () => {
  const navigate = useNavigate();
  const [totalGroups, setTotalGroups] = useState(null);
  const [loadingGroups, setLoadingGroups] = useState(false);

  useEffect(() => {
    let active = true;
    setLoadingGroups(true);
    fetchAllGroups()
      .then((data) => {
        if (!active) return;
        const count = Array.isArray(data) ? data.length : 0;
        setTotalGroups(count);
      })
      .catch((e) => {
        if (!active) return;
        console.error('Ocakbaşı grupları sayısı alınamadı:', e);
        setTotalGroups(null);
      })
      .finally(() => {
        if (active) setLoadingGroups(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <Card sx={{ border: '1px solid #f1f1f1', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
      <CardActionArea onClick={() => navigate('/groups')}>
        <CardContent sx={{ p: 2.5 }}>
          <Stack>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                backgroundColor: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 3,
              }}
            >
              <FaUserFriends style={{ fontSize: '20px', color: '#0E4D94' }} />
            </Box>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#666666', mb: .5 }}>
              Ocakbaşı Grupları
            </Typography>
            <Typography sx={{ fontSize: '28px', fontWeight: 700, color: '#444444' }}>
              {loadingGroups ? '-' : (totalGroups !== null ? totalGroups : '-')}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default OcakbaşıGruplarıKartı;
